import { CreateEventRequest, DeleteEventPictureRequest, GetAdminEventByIdRequest, GetAdminEventRequest, UpdateEventPictureRequest, UpdateEventRequest } from "@aoe/client";
import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { CreateEventResponse, EventAdminDetailResponse, EventAdminListResponse, UpdateEventResponse } from "src/app/core/interfaces/EventsResponse.interface";

export const EventAdminActions = createActionGroup({
    source: '[Event Admin]',
    events: {

        'Load Event List': props<{ payload: GetAdminEventRequest }>(),
        'Load Event List Success': props<EventAdminListResponse>(),
        'Load Event List Failed': props<{ error: any }>(),

        'Load Event Detail': props<{ payload: GetAdminEventByIdRequest }>(),
        'Load Event Detail Success': props<EventAdminDetailResponse>(),
        'Load Event Detail Failure': props<EventAdminDetailResponse>(),

        'Update Cover Picture': props<{ payload: UpdateEventPictureRequest, id: string }>(),
        'Update Cover Picture Success': props<{ eventId: string; pictureUrl: string }>(),
        'Update Cover Picture Failure': props<{ error: string }>(),

        'Create event': props<{ payload: CreateEventRequest }>(),
        'Create event success': props<CreateEventResponse>(),
        'Create event failed': props<CreateEventResponse>(),

        'Update event': props<{ payload: UpdateEventRequest, id: string }>(),
        'Update event success': props<UpdateEventResponse>(),
        'Update event failed': props<UpdateEventResponse>(),

        'Delete Cover Picture': props<{ payload: DeleteEventPictureRequest }>(),
        'Delete Cover Picture Success': props<DeleteEventPictureRequest>(),
        'Delete Cover Picture Failure': emptyProps(),


        'Reset List': emptyProps(),
        'Reset selected event': emptyProps()
    },
});